import { Component, OnInit } from '@angular/core';
import { CardComponent } from '@microsec/components';
import { BaseComponent } from '@ids-components';
import { AccessTokenService } from '@ids-services';
import { finalize } from 'rxjs/operators';
import { PasswordConfirmationFormComponent } from './password-confirmation-form/password-confirmation-form.component';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-token-management',
  templateUrl: './token-management.component.html',
  styleUrls: ['./token-management.component.scss'],
  imports: [CommonModule, ButtonModule, TooltipModule, CardComponent],
})
export class TokenManagementComponent extends BaseComponent implements OnInit {
  isLoading = true;

  tokens: any[] = [];

  constructor(private accessTokenSrv: AccessTokenService) {
    super();
  }

  async ngOnInit() {
    this.isLoading = false;
    await this.prepareConfigs();
    this.getConsents();
  }

  getConsents() {
    this.isLoading = true;
    this.accessTokenSrv
      .getConsents(this.keycloakAuthSrv.keycloakData()?.subject)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        }),
      )
      .subscribe({
        next: (res) => {
          this.tokens = (res?.[0]?.additionalGrants as any[]) || [];
        },
        error: (error) => {
          this.showErrorMessage(error);
        },
      });
  }

  openPasswordConfirmationForm() {
    const dialog = this.dialogSrv.open(PasswordConfirmationFormComponent, {
      header: `Password Confirmation`,
      width: '800px',
      height: 'min-content',
      closable: false,
      modal: true,
    });
    dialog.onClose.subscribe((rs) => {
      if (!!rs) {
        this.getConsents();
      }
    });
  }

  confirmAllTokensRevocation() {
    this.confirm({
      action: 'Revoke',
      objectName: 'All Offline Tokens',
      customContent:
        `Are you sure you want to revoke all offline tokens?<br/><br/>` +
        `This will invalidate all previously generated tokens. ` +
        `Any systems or applications using these tokens will lose access immediately.<br/><br/>` +
        `You can generate new tokens after revoking.`,
      acceptLabel: 'Revoke Tokens',
      acceptRequest: this.accessTokenSrv.deleteOfflineToken(this.keycloakAuthSrv.keycloakData()?.subject),
      next: () => {
        this.showSuccessMessage('Revoked offline tokens successfully.');
        this.getConsents();
      },
      error: (error) => {
        this.showErrorMessage(error);
      },
    });
  }
}
